import { all, put, select, takeEvery } from 'redux-saga/effects';
import { flagEnabled } from '../../redux/flags/selectors';
import { newPageLoaded, logLastAdRefresh } from './actions';
import { getLastRefresh, getAdsRefreshCount } from './selectors';
import ddt from '@wix/da-ddt';
import { adsRefreshTimeout, maxAdsRefresh } from './constants';
import { getAdsEnabled } from '../../publicSession/selectors';
function canRefresh(last) {
    if (performance.now() - last >= adsRefreshTimeout) {
        return true;
    }
    return false;
}
/**
 * This signals a new pageview to freestar.
 *
 * This refreshes ads when the page url changes, but only once every 30s. It does
 * not handle timed refresh, that is handled by freestar and is set to much longer
 * currently 4m.
 *
 * The idea is to maintain good viewability and make sure we get fresh ads when the
 * main content changes but not too often if the user is moving fast.
 *
 * Total refreshes are also capped to 60 currently.
 */ function* handlePageLoaded() {
    var // Signal for new pageview
    _window_freestar, _window_freestar_queue;
    const isFreestar = yield select(flagEnabled, 'ads_freestar');
    const adsEnabled = yield select(getAdsEnabled);
    const lastRefresh = yield select(getLastRefresh);
    const refreshCount = yield select(getAdsRefreshCount);
    if (!isFreestar || !adsEnabled || typeof window === 'undefined') {
        return;
    }
    (_window_freestar = window['freestar']) === null || _window_freestar === void 0 ? void 0 : (_window_freestar_queue = _window_freestar.queue) === null || _window_freestar_queue === void 0 ? void 0 : _window_freestar_queue.push(function() {
        window['freestar'].trackPageview();
        ddt.log('ads', 'FS pageview');
    });
    // Handle refreshing after page changes
    if (canRefresh(lastRefresh) && refreshCount <= maxAdsRefresh) {
        var _window_freestar1, _window_freestar_queue1;
        (_window_freestar1 = window['freestar']) === null || _window_freestar1 === void 0 ? void 0 : (_window_freestar_queue1 = _window_freestar1.queue) === null || _window_freestar_queue1 === void 0 ? void 0 : _window_freestar_queue1.push(function() {
            window['freestar'].refreshActiveSlots();
            ddt.log('ads', 'Ads Refresh Triggered');
        });
        yield put(logLastAdRefresh(performance.now()));
    }
}
export default function* adsSaga() {
    yield all([
        takeEvery(newPageLoaded, handlePageLoaded)
    ]);
}
